import http from "@/http-common";

class ConfigurationService {
    getConfiguration() {
        var user = JSON.parse(localStorage.getItem('user'));
        var ssid = user["ssid"];
        var token = localStorage.getItem('jwt');
        var data = {headers:{jwt : token, ssid : ssid}}

        return http.get("/configuration", data);
    }

    getConfigurationBySsid(configurationSsid) {
        var user = JSON.parse(localStorage.getItem('user'));
        var ssid = user["ssid"];
        var data = {headers:{jwt : localStorage.getItem('jwt'), ssid: ssid}}
    
        return http.get(`/configuration/ssid/${configurationSsid}`, data);
    }

    updateConfiguration (data) {
        var user = JSON.parse(localStorage.getItem('user'));
        var ssid = user["ssid"];
    
        var resData = {};
        resData.configuration = data;
        resData.jwt = localStorage.getItem('jwt')
        resData.ssid = ssid;
        
        return http.put(`/configuration`, resData);
    }

    setDefaultConfiguration() {
        var user = JSON.parse(localStorage.getItem('user'));
        var ssid = user["ssid"];
        var token = localStorage.getItem('jwt');
        var data = {headers:{jwt : token, ssid : ssid}}

        return http.get("/configuration/default", data);
    }

    sendConfiguration() {
        var user = JSON.parse(localStorage.getItem('user'));
        var ssid = user["ssid"];
        var token = localStorage.getItem('jwt');
        var data = {headers:{jwt : token, ssid : ssid}}

        return http.get("/configuration/send", data);
    }

}

export default new ConfigurationService();